import { render } from "./DropBalanceSettings.vue?vue&type=template&id=10cc363e&scoped=true"
import script from "./DropBalanceSettings.vue?vue&type=script&lang=js"
export * from "./DropBalanceSettings.vue?vue&type=script&lang=js"

import "./DropBalanceSettings.vue?vue&type=style&index=0&id=10cc363e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cc363e"]])

export default __exports__